var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"plainToast"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_dialog),expression:"show_dialog"}],staticClass:"plain-dialog"},[_c('i',{class:[{'dialog-icon': _vm.type !== undefined}, ( _obj = {}, _obj['dialog-icon-' + _vm.getDialogType()] = true, _obj )]}),_vm._v(_vm._s(_vm.text)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }